export default __webpack_public_path__ + "static/media/20230601_184004 - Nishchal.7cd7ed99.jpg";